import { gql } from '@apollo/client';

const DOWNLOAD_PDF_REPORT_MUTATIONS = gql`
  mutation downloadPdfReport(
    $studyFid: Int
    $reportType: String
    $eventFid: Int
    $reportId: Int
    $markAsDownloaded: Boolean
  ) {
    downloadPdfReport(
      studyFid: $studyFid
      reportType: $reportType
      eventFid: $eventFid
      reportId: $reportId
      markAsDownloaded: $markAsDownloaded
    ) {
      isSuccess
      message
      url
    }
  }
`;

export default DOWNLOAD_PDF_REPORT_MUTATIONS;
